import { useContext } from "react";
import { AppContext } from "../App";
import { FiHeart, FiShield, FiEye, FiActivity } from "react-icons/fi";

export default function MaternalChildHealth() {
  const appContext = useContext(AppContext);

  const services = [
    {
      icon: <FiHeart />,
      title: "Maternal & Child Health (MCH) Clinic",
      desc: "Comprehensive services encompassing antenatal care, postnatal follow-up, newborn health assessment, growth monitoring, and child wellness."
    },
    {
      icon: <FiShield />,
      title: "Immunization Clinic (EPI)",
      desc: "Delivering the full National vaccination schedule for infants and children, alongside recommended adult boosters and vaccines."
    },
    {
      icon: <FiEye />,
      title: "Cervical Cancer Screening Clinic",
      desc: "Positioned to address early diagnostics through visual screening metrics, fast-track specialist referral pathways, vaccination, and systematic education."
    },
    {
      icon: <FiActivity />,
      title: "Sexual & Reproductive Health (SRH)",
      desc: "Comprehensive family planning, routine STI screening and clinical management, specialized adolescent health pathways, and HIV prevention options (PrEP)."
    }
  ];

  return (
    <div className="pillar-container">
      <div className="pillar-header">
        <h2 className="pillar-title">Maternal, Child & Reproductive Health</h2>
        <p className="pillar-subtitle">Protecting future generations through evidence-based screening and preventative family clinics.</p>
      </div>

      <div className="pillar-grid">
        {services.map((item, idx) => (
          <div 
            key={idx} 
            className="pillar-card"
            onClick={() => appContext.navTo({ item: "contact_us" })}
          >
            <div className="pillar-icon">{item.icon}</div>
            <h3 className="pillar-card-title">{item.title}</h3>
            <p className="pillar-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}